module.exports = __webpack_public_path__ + "static/media/female1.98ad9cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/female1.png
// module id = 898
// module chunks = 0